/* eslint-disable */
/* eslint-disable no-plusplus */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef, useReducer, useState } from "react";
import { NotificationManager } from "react-notifications";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import api from "api";
import { Form } from "react-bootstrap";
import { useAuth } from "context/auth";
import clearDuplicatedItemFromArrOfObject from "utils/clearDuplicatedItemFromArrOfObject";
import { useEsriUrls } from "context/esriUrlsContext";
import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import Dialog from "components/Dialog/Dialog";
import BaseCard from "components/BaseCard";
import PrintParcels from "components/PrintParcels";
import getEsriData from "context/contextFunctions/getEsriData";
// import getFeature from "utils/getFeature";
import joinVillsAndHodsIntoData from "utils/selfUtils/joinVillsAndHodsIntoData";
import { fixParcelDataPadding } from "utils/selfUtils/getParcelsBasedCriteria";
import ValidateOwnership from "./ValidateOwnership";
import { getHodAndVillNames } from "../ParcelsSearch";
import axios from "axios";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function findMaxObject(array, attribute) {
  let maxObject = array[0];
  let maxValue = array[0][attribute];
  for (let i = 1; i < array.length; i++) {
    if (array[i][attribute] > maxValue) {
      maxObject = array[i];
      maxValue = array[i][attribute];
    }
  }
  return maxObject;
}

function MyRequests() {
  const [auth] = useAuth();
  const [badServerError, setBadServerError] = useState();
  const [esriUrls] = useEsriUrls();
  const [map] = useMap();
  const [, dispatchLoading] = useLoading();

  const [selectedLand, setSelectedLand] = useState(null);
  const [hods, setHods] = useState(null);

  const { view } = map;
  const [lands, setLands] = useState(null);
  const [allLands, setAllLands] = useState(null);
  const hodInput = useRef(null);
  const [validateOwnershipDialogState, validateOwnershipDispatchDialog] =
    useReducer(dialogReducer, dialogInitState);


  const handleGetRegulationPrice = async (data) => {
    
    handleLoading(dispatchLoading, true);
    try {
      let usage;
      let price;
      let code;
      const query = `DLS_KEY ='${data.DLS_KEY}'`;
      // First check if parcel exists in Parcels_Intersect layer
      const { res: parcelIntersectRes } = await getEsriData({
        view,
        layerId: esriUrls.Parcels_Intersect,
        layer: process.env.REACT_APP_PetraLayers_Table,
        query,
        featureOrMap: "MapServer",
        neededDomains: ["ZONE_ID"],
        token: auth.esriToken,
      });
      if (parcelIntersectRes?.length) {
        // if parcel exists in Parcels_Intersect layer get price from RegulationsPrice layer
        const priceQuery = `code IN (${parcelIntersectRes.map(
          (item) => `${item.ZONE_ID}`
        )})`;
        const { res: intersectRegulationsPriceRes } = await getEsriData({
          view,
          layerId: esriUrls.RegulationsPrice,
          layer: process.env.REACT_APP_UserTables_Table,
          query: priceQuery,
          featureOrMap: "MapServer",
          token: auth.esriToken,
        });
        usage = `${intersectRegulationsPriceRes.map((reg) => reg.name)}`;
        price = findMaxObject(intersectRegulationsPriceRes, "price").price;
        code = findMaxObject(intersectRegulationsPriceRes, "price").code;
      } else if (!parcelIntersectRes?.length) {
        // if parcel does not exist in Parcels_Intersect layer check in TPZ_Intersect layer
        const tpzQuery = `DLS_KEY ='${data.DLS_KEY}'`;
        const { res: tpzIntersectRes } = await getEsriData({
          view,
          layerId: esriUrls.TPZ_Intersect,
          layer: process.env.REACT_APP_PetraLayers_Table,
          query: tpzQuery,
          featureOrMap: "MapServer",
          token: auth.esriToken,
        });

        if (tpzIntersectRes?.length) {
          // if parcel exists in TPZ_Intersect layer get TPZ price from RegulationsPrice layer
          const tpzPriceQuery = `name='TPZ'`;
          const { res: tpzRegulationsPriceRes } = await getEsriData({
            view,
            layerId: esriUrls.RegulationsPrice,
            layer: process.env.REACT_APP_UserTables_Table,
            query: tpzPriceQuery,
            featureOrMap: "MapServer",
            token: auth.esriToken,
          });

          usage = `${tpzIntersectRes.map((item) => item.LANDUSE_A)}`;
          price = findMaxObject(tpzRegulationsPriceRes, "price").price;
          code = findMaxObject(tpzRegulationsPriceRes, "price").code;
        } else if (!tpzIntersectRes?.length) {
          // if parcel does not exist in TPZ_Intersect layer check in ZONING_LAND_USE_PLAN_SEGMA layer
          const { res: segmaRes } = await getEsriData({
            view,
            layerId: esriUrls.ZONING_LAND_USE_PLAN_SEGMA,
            layer: process.env.REACT_APP_PetraLayers_Table,
            geometry: data.geometry,
            featureOrMap: "MapServer",
            token: auth.esriToken,
          });
          // if parcel exists in ZONING_LAND_USE_PLAN_SEGMA layer get SEGMA price from RegulationsPrice layer
          const segmaPriceQuery = `name='SEGMA'`;
          const { res: segmaRegulationsPriceRes } = await getEsriData({
            view,
            layerId: esriUrls.RegulationsPrice,
            layer: process.env.REACT_APP_UserTables_Table,
            query: segmaPriceQuery,
            featureOrMap: "MapServer",
            token: auth.esriToken,
          });
          usage = `${segmaRes.map((item) => ` ${item.LANDUSE_A} `)}`;
          price = findMaxObject(segmaRegulationsPriceRes, "price").price;
          code = findMaxObject(segmaRegulationsPriceRes, "price").code;
        }
      }
      setSelectedLand({ ...data, usage, price, code });
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(dispatchLoading, false);
  };

  const toggleValidateOwnershipDialog = async (data) => {
    if (data) {
      await handleGetRegulationPrice(data);
      // setSelectedLand(data);
    }
    validateOwnershipDispatchDialog({ type: "TOGGLE" });
  };
  // *****
  const [printDialogState, printDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );

  const togglePrintDialog = (data) => {
    if (data) setSelectedLand(data);
    printDispatchDialog({ type: "TOGGLE" });
  };

  const CardActions = useMemo(
    () => ({
      actionA: toggleValidateOwnershipDialog,
      actionB: togglePrintDialog,
    }),
    [esriUrls, view]
  );

  const getUserLands = async () => {
    try {
      handleLoading(dispatchLoading, true);

      const landsRes = await api.get("lands");      
      if (landsRes.status === 204) {
        setLands(null);
        setAllLands(null);
        handleLoading(dispatchLoading, false);
        return;
      }
      const landsDlsList = [
        ...new Set(landsRes.data.list.map((item) => `'${item.dlsKey}'`)),
      ];
      const landsQuery = `DLS_KEY IN (${landsDlsList})`;
    
      const isNotPrintableResult=await api.post("/lands/print/blocked",{dlsKeyArray:[
        ...new Set(landsRes.data.list.map((item) =>item.dlsKey)),
      ]});
      const isNotPrintableDlsKeys = isNotPrintableResult?.data?.data?.list?.map(
        (item) => item
      );

      const { res: landsEsriRes, serverFeatureLayerQuery } = await getEsriData({
        view,
        layerId: esriUrls.DLSParcelsLayer,
        layer: process.env.REACT_APP_DLSParcelsLayer_Table,
        query: landsQuery,
        featureOrMap: "MapServer",
        token: auth.esriToken,
      });

      if (!serverFeatureLayerQuery.features) {
        NotificationManager.warning(
          "معلومات دائرة الأراضي غير متوفرة حاليا الرجاء إعادة تحميل الصفحة"
        );
        setBadServerError(
          "معلومات دائرة الأراضي غير متوفرة حاليا الرجاء إعادة تحميل الصفحة"
        );
      }
      // landsEsriRes = landsEsriRes.map((item) => fixParcelDataPadding(item));
      const { res: landsEsriResWithNames, hodsRes } =
        await joinVillsAndHodsIntoData({
          data: landsEsriRes,
          esriToken: auth.esriToken,
          villLayerId: esriUrls.villagesLookup,
          hodLayerId: esriUrls.hodesLookUp,
        });


      const landsWithIsPrintable = landsEsriResWithNames.map((item) => ({
        ...item,
        IS_PRINTABLE: !isNotPrintableDlsKeys.includes(item.DLS_KEY),
        area: landsRes.data.list.find((land) => land.dlsKey === item.DLS_KEY)
          .area,
      }));
            
      setHods(hodsRes);
      setAllLands(landsWithIsPrintable);
      setLands(landsWithIsPrintable);
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(dispatchLoading, false);
  };

  useEffect(() => {
    (async () => {
      if ((esriUrls.Parcels_Intersect, view)) {
        await getUserLands();
      }
    })();
  }, [auth.token, esriUrls.Parcels_Intersect, view]);

  const handleFilterChange = () => {
    if (!allLands) return;
    const hodValue = hodInput.current.value;
    const filteredLands = allLands?.filter((land) => {
      if (!hodValue) return true;
      return land.HOD_ANAME == hodValue;
    });
    setLands(clearDuplicatedItemFromArrOfObject(filteredLands, "DLS_KEY"));
  };
  return (
    <>
      <h2 className="content__title title mt-3">الأراضي الخاصة بي</h2>
      <div
        className="lands_filter"
        style={{ display: "grid", gap: "1rem", marginBottom: "1rem" }}
      >
        <div>
          <Form.Label>الحوض</Form.Label>
          <Form.Select
            defaultValue=""
            onChange={handleFilterChange}
            ref={hodInput}
          >
            <option value="">ادخل الحقل للتصفية</option>
            {hods?.map((item) => (
              <option value={item.HOD_ANAME} key={item.HOD_ANAME}>
                {item.HOD_ANAME}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>
      {lands?.length ? <p>الأراضي المعروضة: {lands.length}</p> : null}
      <div>
        {lands?.map((item) => (
          <BaseCard
            key={item.OBJECTID}
            actions={CardActions}
            cardDetails={item}
          />
        ))}
        {!lands && <p className="text-center">لا يوجد اراضي لعرضها</p>}
        {badServerError && (
          <p className="text-center text-danger">{badServerError}</p>
        )}لا يوجد اراضي لعرضها


      </div>
      <Dialog
        state={validateOwnershipDialogState}
        dispatch={validateOwnershipDispatchDialog}
        footer={false}
        title="التحقق من ملكية قطعة ارض"
        closeButton
        centered
      >
        <ValidateOwnership
          data={selectedLand}
          toggleDialog={toggleValidateOwnershipDialog}
        />
      </Dialog>
      <Dialog
        state={printDialogState}
        dispatch={printDispatchDialog}
        footer={false}
        title="تحديد مقياس الرسم لمخطط الموقع"
        closeButton
        centered
      >
        <PrintParcels
          isDraft
          printData={selectedLand}
          toggleDialog={togglePrintDialog}
        />
      </Dialog>
    </>
  );
}

export default MyRequests;
